import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { stroke: "currentColor", strokeWidth: 2 }, /* @__PURE__ */ React.createElement("path", { d: "m15.589 8.721-3.79 3.79-2.308-2.312-3.08 3.08" }), /* @__PURE__ */ React.createElement("path", { d: "M1 11a10 10 0 1 0 20 0 10 10 0 0 0-20 0zM22.583 22.583l-4.506-4.506" })));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
